var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaLLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 14.2 16",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6,0H3.5v1.1h7.1V0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13,14.9H0V16h14.2v-5.3H13V14.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7,3.2V2.1H8L3.8,13.9h8v-3.2h-1.2v2.1H5.4l3.4-9.6H10.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0,12.8v1.1h2.5L6.7,2.1H3.5v1.1h1.5l-3.4,9.6H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaLLogo);
export default __webpack_public_path__ + "static/media/la_L_logo.a15b281c47b8efc01d093ccfdc62a8c8.svg";
export { ForwardRef as ReactComponent };